import { useMemo, useState } from 'react';
import { useGameFeature } from './useGameFeature';

export type useGlobalUserDataState = ReturnType<typeof useGlobalUserData>;
export const useGlobalUserData = () => {
    //not usually update user ac data
    const {
        isHedgeBettingEnabled,
        isAutoConfirmEnabled,
        isSideBetEnabled,
        isDTSideBetEnabled,
    } = useGameFeature();
    const [gameNotSupportAutoConfirm, setNotSupportAutoConfirm] =
        useState<boolean>(false);
    const isAutoConfirm = useMemo(
        () => isAutoConfirmEnabled && !gameNotSupportAutoConfirm,
        [isAutoConfirmEnabled, gameNotSupportAutoConfirm]
    );
    const [supportPixi, setSupportPixi] = useState<boolean | undefined>(
        undefined
    );

    return {
        isAutoConfirmEnabled,
        isHedgeBettingEnabled,
        isAutoConfirm,
        isSideBetEnabled,
        isDTSideBetEnabled,
        setNotSupportAutoConfirm,
        supportPixi,
        setSupportPixi,
    };
};
